/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const EmailVerificationFlow = zod
  .object({
    csrfToken: zod.string(),
    email: zod.email(),
    expiresAt: zod.string(),
    flowId: zod.string().min(1),
  })
  .describe(
    'Verification flow state to echo back on \/me\/emails\/verify. Absent when the OTP email could not be dispatched (the address was still added; use \/me\/emails\/resend).',
  );

export type EmailVerificationFlow = zod.input<typeof EmailVerificationFlow>;
export type EmailVerificationFlowOutput = zod.output<typeof EmailVerificationFlow>;
